import cx from 'classnames';
import {useCallback, useEffect, useState} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {FlipIcon} from '~library/svg/FlipIcon';
import {tanzanite} from '~libSass/base/_exports.sass';
import {webviewFlipCard} from './webviewMessages';
import './FlipCard.sass';

export const FlipCard = ({CardFront, CardBack, ref}) => {
  const [flipped, setFlipped] = useState(false);

  const onCardFlip = useCallback(() => {
    setFlipped((isFlipped) => !isFlipped);
    webviewFlipCard();
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    if (ref.current) {
      ref.current.setCardFlipped = (value) => setFlipped(value);
    }
  }, [!!ref.current]);

  return (
    <div ref={ref} className={cx('flip-card', {flipped})}>
      <Button
        variant="raised"
        size="small"
        className="flip-card__button"
        onClick={onCardFlip}
        data-qa-id="flip-card"
        type="button"
      >
        <FlipIcon ratio={0.7} color={tanzanite} />
        <Typography
          as="span"
          variant="link"
          size="medium"
          data-qa-id="flipCardText"
          color="tanzanite"
        >
          Flip card
        </Typography>
      </Button>
      <div
        className="flip-card-inner"
        onClick={onCardFlip}
        onKeyUp={null}
        role="button"
        tabIndex={0}
        aria-label="flip-card"
      >
        <div className="flip-card-front">
          <CardFront />
        </div>
        <div className="fabric_user_card flip-card-back">
          <CardBack />
        </div>
      </div>
    </div>
  );
};
